import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, getInitialLanguage, normalizeLanguage, saveLanguagePreference, SUPPORTED_LANGUAGES } from './language';
import ptCommon from './locales/pt-BR/common.json';
import ptOnboarding from './locales/pt-BR/onboarding.json';
import ptLegal from './locales/pt-BR/legal.json';
import ptErrors from './locales/pt-BR/errors.json';
import esCommon from './locales/es/common.json';
import esOnboarding from './locales/es/onboarding.json';
import esLegal from './locales/es/legal.json';
import esErrors from './locales/es/errors.json';
import enCommon from './locales/en/common.json';
import enOnboarding from './locales/en/onboarding.json';
import enLegal from './locales/en/legal.json';
import enErrors from './locales/en/errors.json';
import ptApp from './locales/pt-BR/app.json';
import esApp from './locales/es/app.json';
import enApp from './locales/en/app.json';
import ptComparison from './locales/pt-BR/comparison.json';
import esComparison from './locales/es/comparison.json';
import enComparison from './locales/en/comparison.json';

const i18n = createInstance();

i18n.use(initReactI18next).init({
  resources: {
    'pt-BR': { common: ptCommon, onboarding: ptOnboarding, legal: ptLegal, errors: ptErrors, app: ptApp, comparison: ptComparison },
    es: { common: esCommon, onboarding: esOnboarding, legal: esLegal, errors: esErrors, app: esApp, comparison: esComparison },
    en: { common: enCommon, onboarding: enOnboarding, legal: enLegal, errors: enErrors, app: enApp, comparison: enComparison },
  },
  lng: getInitialLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: SUPPORTED_LANGUAGES.map(({ code }) => code),
  load: 'currentOnly',
  ns: ['common', 'onboarding', 'legal', 'errors', 'app', 'comparison'],
  defaultNS: 'common',
  initAsync: false,
  returnEmptyString: false,
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

const updateDocumentLanguage = () => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = normalizeLanguage(i18n.resolvedLanguage || i18n.language) || DEFAULT_LANGUAGE;
  const description = document.querySelector('meta[name="description"]');
  if (description) description.content = i18n.t('metadata.description');
};

i18n.on('languageChanged', updateDocumentLanguage);
updateDocumentLanguage();

export const changeLanguage = async (language, instance = i18n) => {
  const supported = normalizeLanguage(language);
  if (!supported) return;
  await instance.changeLanguage(supported);
  saveLanguagePreference(supported);
};

export default i18n;
